import React, { useEffect } from 'react';
import { isBefore } from 'date-fns';

import { EntityTagEvent_EventType } from '@weave/schema-gen-ts/dist/apis/api/wetags/v1/api.pb';

import { OnOffIndicator } from 'components/shared/on-off-indicator/on-off-indicator.component';
import { useReportEntityTagHistoryQuery } from 'apis/wetags';

type EntityTagEventsProps = {
  namespaceId: string;
  tagId: string;
  entityId: string;
  refreshKey: number;
};

export const EntityTagEvents = (props: EntityTagEventsProps) => {
  const entityTagEventsQuery = useReportEntityTagHistoryQuery({
    namespaceId: props.namespaceId,
    tagId: props.tagId,
    entityId: props.entityId,
  });

  useEffect(() => {
    entityTagEventsQuery.refetch();
  }, [props.refreshKey]);

  if (entityTagEventsQuery.isLoading) {
    return <span>Loading...</span>;
  } else if (entityTagEventsQuery.isError) {
    return <> Error loading events: {String(entityTagEventsQuery.error)} </>;
  } else if (!entityTagEventsQuery.data && entityTagEventsQuery.isFetched) {
    return <> No events </>;
  } else {
    return (
      <div>
        {entityTagEventsQuery.data?.events ? (
          <table className={'table table-bordered'}>
            <thead>
              <tr>
                <th>Date</th>
                <th>User</th>
                <th>Operation</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {entityTagEventsQuery.data.events
                .sort((eventA, eventB) =>
                  isBefore(new Date(eventA.setTime ?? ''), new Date(eventB.setTime ?? ''))
                    ? 1
                    : -1
                )
                .map((event, i: number) => {
                  return (
                    <tr key={event.setTime}>
                      <th>{new Date(event.setTime ?? '').toUTCString()}</th>
                      <th>{event.actorId}</th>
                      <th>
                        {i == (entityTagEventsQuery.data.events?.length ?? 0) - 1 &&
                        event.eventType == EntityTagEvent_EventType.REMOVED_PERCENT_BUCKET
                          ? 'NOT_IN_PERCENT' // should probably be done upstream
                          : event.eventType}
                      </th>
                      <th>
                        <OnOffIndicator on={event.tagExists || false} />
                      </th>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        ) : (
          <div>No History Found</div>
        )}
      </div>
    );
  }
};
